import StatusDisplayer from "@components/StatusDisplayer";
import { FC } from "react";

const Status: FC = () => {
  return <StatusDisplayer />;
};

export default Status;
